import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import * as log from '../log';
import { isHConcatSpec, isVConcatSpec } from '../spec';
import { BaseConcatModel } from './baseconcat';
import { buildModel } from './buildmodel';
import { parseConcatLayoutSize } from './layoutsize/parse';
export var ConcatModel = /*#__PURE__*/function (_BaseConcatModel) {
  _inherits(ConcatModel, _BaseConcatModel);

  function ConcatModel(spec, parent, parentGivenName, repeater, config) {
    var _this;

    _classCallCheck(this, ConcatModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConcatModel).call(this, spec, 'concat', parent, parentGivenName, config, repeater, spec.resolve));

    if (spec.resolve && spec.resolve.axis && (spec.resolve.axis.x === 'shared' || spec.resolve.axis.y === 'shared')) {
      log.warn(log.message.CONCAT_CANNOT_SHARE_AXIS);
    }

    _this.concatType = isVConcatSpec(spec) ? 'vconcat' : isHConcatSpec(spec) ? 'hconcat' : 'concat';
    _this.children = _this.getChildren(spec).map(function (child, i) {
      return buildModel(child, _assertThisInitialized(_assertThisInitialized(_this)), _this.getName('concat_' + i), undefined, repeater, config, false);
    });
    return _this;
  }

  _createClass(ConcatModel, [{
    key: "getChildren",
    value: function getChildren(spec) {
      if (isVConcatSpec(spec)) {
        return spec.vconcat;
      } else if (isHConcatSpec(spec)) {
        return spec.hconcat;
      }

      return spec.concat;
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseConcatLayoutSize(this);
    }
  }, {
    key: "parseAxisGroup",
    value: function parseAxisGroup() {
      return null;
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      return Object.assign({}, this.concatType === 'vconcat' ? {
        columns: 1
      } : {}, {
        bounds: 'full',
        // Use align each so it can work with multiple plots with different size
        align: 'each'
      });
    }
  }]);

  return ConcatModel;
}(BaseConcatModel);